export default {
  tournaments: {
    aba: ["#0064B2", "#F36A22"],
    atp: ["#002865", "#00AFF0"],
    auopen: ["#6C935C", "#3C638E"],
    basketballworldcup: ["#FF2C00", "#0131FF", "#FFC92D"],
    billijean: ["#00303C", "#DFE5E7", "#607E86"],
    caf: ["#039141", "#F6E023", "#DBB400"],
    chg: ["#496928", "#E1E6DB"],
    clhandball: ["#001432", "#C4B457"],
    concacaf: ["#EFE4CD", "#636364"],
    copaamerica: ["#00599E", "#A8A7A5", "#E8472F"],
    daviscup: ["#259271", "#FFFFFF"],
    dcs: ["#FFFFFF", "#F59E0F"],
    eurochampionship: ["#000000", "#A58746", "#EAE3D4"],
    eurocup: ["#0972CF", "#F4F8FC"],
    euroleague: ["#FA5500", "#FEFDFC"],
    exh: ["#6C9B48", "#FFFFFF"],
    fiba: ["#C8102E", "#FFD100"],
    hpm: ["#2B96FF", "#FFFFFF"],
    ipt: ["#B23938", "#FFFFFF"],
    itf: ["#009980", "#FFCB05"],
    mlb: ["#0E499D", "#FFFFFF", "#D30529"],
    mmr: ["#0081C8", "#FCB131", "#00A651", "#EE334E"],
    nba: ["#1D428A", "#C8102E"],
    nfl: ["#0E499D", "#D30529"],
    nhl: ["#000000", "#E4E5E6"],
    sehaleague: ["#E42E30", "#1080CD", "#234FA8"],
    u20conmebol: ["#FFFFFF", "#7F7F7F"],
    uefachampionsleague: ["#FFFFFF", "#231F20"],
    uefaconferenceleague: ["#00BB31", "#000000"],
    uefaeuropeleague: ["#FF6900", "#000000"],
    usopen: ["#00288C", "#FFD400", "#FFFFFF"],
    wcqualification: ["#DA002C", "#015595", "#B69500"],
    wnba: ["#FA4D00", "#000000"],
    worldcup: ["#000000", "#FFFFFF"],
    wta: ["#831D7A", "#6D217D", "#452A82"],
  },
  countries: {
    dza: ["#008000", "#FFFFFF", "#FF0000"],
    ago: ["#FF0000", "#000000", "#FFFF00"],
    ben: ["#008000", "#FFFF00", "#FF0000"],
    bwa: ["#76ACDC", "#000000", "#FFFFFF"],
    bfa: ["#FF0000", "#008000", "#FFFF00"],
    bdi: ["#FF0000", "#FFFFFF", "#008000"],
    cmr: ["#008000", "#FF0000", "#FFFF00"],
    cpv: ["#0000FF", "#FFFFFF", "#FF0000", "#FFFF00"],
    caf: ["#0000FF", "#FFFFFF", "#008000", "#FFFF00", "#FF0000"],
    tcd: ["#00008B", "#FFD700", "#CC0000"],
    com: ["#FFFF00", "#FFFFFF", "#FF0000", "#0000FF", "#008000"],
    dji: ["#75AADB", "#008000", "#FFFFFF", "#FF0000"],
    egy: ["#FF0000", "#FFFFFF", "#000000"],
    gnq: ["#008000", "#FFFFFF", "#FF0000", "#007FFF"],
    eri: ["#008000", "#007FFF", "#FF0000", "#FFFF00"],
    eth: ["#008000", "#FFFF00", "#FF0000", "#0000FF"],
    gab: ["#008000", "#FFFF00", "#0000FF"],
    gmb: ["#FF0000", "#00008B", "#008000", "#FFFFFF"],
    gha: ["#FF0000", "#FFFF00", "#008000", "#000000"],
    gnb: ["#FF0000", "#FFFF00", "#008000", "#000000"],
    civ: ["#FFA500", "#FFFFFF", "#008000"],
    ken: ["#000000", "#FF0000", "#008000", "#FFFFFF"],
    lso: ["#00008B", "#FFFFFF", "#008000", "#000000"],
    lbr: ["#FF0000", "#FFFFFF", "#00008B"],
    lby: ["#FF0000", "#000000", "#008000", "#FFFFFF"],
    mdg: ["#FC3B2E", "#008000", "#FFFFFF"],
    mwi: ["#000000", "#FF0000", "#008000"],
    mli: ["#008000", "#FFFF00", "#FF0000"],
    mrt: ["#008000", "#FFFF00", "#FF0000"],
    mus: ["#FF0000", "#000080", "#FFFF00", "#008000"],
    mar: ["#C22229", "#006230"],
    moz: ["#008000", "#000000", "#FFFF00", "#FF0000", "#FFFFFF"],
    nam: ["#0000FF", "#FF0000", "#008000", "#FFFFFF", "#FFFF00"],
    ner: ["#E05206", "#FFFFFF", "#0DB02B"],
    nga: ["#008000", "#FFFFFF"],
    rwa: ["#00A3DF", "#FFFF00", "#008000"],
    stp: ["#12AD2B", "#FFFF00", "#FF0000", "#000000"],
    sen: ["#008000", "#FFFF00", "#FF0000"],
    syc: ["#0000FF", "#FFFF00", "#FF0000", "#FFFFFF", "#008000"],
    sle: ["#008000", "#FFFFFF", "#0000FF"],
    som: ["#007FFF", "#FFFFFF"],
    zaf: ["#FF0000", "#008000", "#0000FF", "#FFD700", "#000000", "#FFFFFF"],
    sdn: ["#FF0000", "#FFFFFF", "#000000", "#008000"],
    tza: ["#008000", "#FFFF00", "#007FFF", "#000000"],
    tgo: ["#008000", "#FFFF00", "#FF0000", "#FFFFFF"],
    tun: ["#FF0000", "#FFFFFF"],
    uga: ["#000000", "#FFFF00", "#FF0000"],
    zmb: ["#008000", "#FF0000", "#000000", "#FFA500"],
    zwe: ["#008000", "#FFFF00", "#FF0000", "#000000", "#FFFFFF"],
    aia: ["#FF861F", "#93CCEA", "#FFFFFF"],
    atg: ["#FF0000", "#FFFFFF", "#0000FF", "#000000", "#FFFF00"],
    abw: ["#FBE870", "#4997D0", "#FF8833", "#ED0A3F"],
    bhs: ["#40E0D0", "#FFFF00", "#000000"],
    brb: ["#00008B", "#FFFF00", "#000000"],
    blz: ["#0066CC", "#FF3F34", "#FFFFFF"],
    bmu: ["#ED0A3F", "#0066FF", "#FFFFFF"],
    vgb: ["#29AB87", "#FBE870", "#FFFFFF"],
    can: ["#FF0000", "#FFFFFF"],
    cri: ["#0000FF", "#FFFFFF", "#FF0000"],
    cub: ["#0000FF", "#FFFFFF", "#FF0000"],
    dma: ["#008000", "#FFFF00", "#000000", "#FFFFFF", "#FF0000"],
    dom: ["#0000FF", "#FFFFFF", "#FF0000"],
    slv: ["#0000FF", "#FFFFFF"],
    grd: ["#01A368", "#F8D568", "#ED0A3F"],
    glp: ["#01A368", "#ED0A3F", "#FFFFFF"],
    gtm: ["#0066FF", "#FFFFFF"],
    hti: ["#0000FF", "#FF0000"],
    hnd: ["#0000FF", "#FFFFFF"],
    mtq: ["#FFFFFF", "#0000FF"],
    mex: ["#008000", "#FFFFFF", "#FF0000"],
    msr: ["#000000", "#1CAC78", "#23145D", "#EE204D", "#FFFFFF"],
    nic: ["#0000FF", "#FFFFFF"],
    pan: ["#0000FF", "#FFFFFF", "#FF0000"],
    pri: ["#FF0000", "#FFFFFF", "#0000FF"],
    kna: ["#008000", "#FF0000", "#FFFFFF"],
    lca: ["#50BFE6", "#FAFA37", "#000000", "#FFFFFF"],
    vct: ["#2243B6", "#FFD82C", "#1CAC78"],
    tto: ["#FF0000", "#FFFFFF", "#000000"],
    usa: ["#FF0000", "#FFFFFF", "#00008B"],
    vir: ["#FFFFFF", "#FFFF66", "#0066FF"],
    arg: ["#75AADB", "#FFFFFF"],
    bol: ["#FF0000", "#FFFF00", "#008000"],
    bra: ["#008000", "#FFFF00"],
    chl: ["#FF0000", "#FFFFFF", "#0000FF"],
    col: ["#FFFF00", "#0000FF", "#FF0000"],
    ecu: ["#FFFF00", "#0000FF", "#FF0000"],
    guf: ["#FFDB00", "#63B76C"],
    pry: ["#FF0000", "#FFFFFF", "#0000FF"],
    per: ["#FF0000", "#FFFFFF"],
    sur: ["#FFFFFF", "#01A368"],
    ury: ["#0000FF", "#FFFFFF"],
    ven: ["#FFFF00", "#0000FF", "#FF0000"],
    arm: ["#FF0000", "#0000FF", "#FFA500"],
    aze: ["#0000FF", "#FF0000", "#008000"],
    bhr: ["#FF0000", "#FFFFFF"],
    bgd: ["#F4263F", "#006A4D", "#FF9900"],
    btn: ["#E48400", "#FFD700", "#FFFFFF"],
    brn: ["#FFFF00", "#000000", "#FFFFFF", "#FF0000"],
    khm: ["#FF0000", "#0000FF"],
    chn: ["#FF0000", "#FFD700"],
    geo: ["#FF0000", "#FFFFFF"],
    hkg: ["#FF0000", "#FFFFFF"],
    idn: ["#FF0000", "#FFFFFF"],
    irq: ["#FF0000", "#FFFFFF", "#000000", "#008000"],
    jpn: ["#FF0000", "#FFFFFF"],
    jor: ["#000000", "#FFFFFF", "#008000", "#FF0000"],
    kaz: ["#007FFF", "#FFFF00"],
    kwt: ["#008000", "#FFFFFF", "#FF0000", "#000000"],
    kgz: ["#FF0000", "#FFFF00"],
    lao: ["#FF0000", "#00008B", "#FFFFFF"],
    lbn: ["#FF0000", "#FFFFFF", "#008000"],
    mys: ["#FFD700", "#000000"],
    mdv: ["#FF0000", "#FFFFFF"],
    mng: ["#0000FF", "#FF0000", "#FFFF00"],
    mmr: ["#FFFF00", "#008000", "#FF0000", "#FFFFFF"],
    npl: ["#DC143C", "#0000FF", "#FFFFFF"],
    omn: ["#FF0000", "#FFFFFF", "#008000"],
    pak: ["#006400", "#FFFFFF"],
    pse: ["#000000", "#FFFFFF", "#008000", "#FF0000"],
    phl: ["#0000FF", "#FF0000", "#FFFFFF", "#FFFF00"],
    qat: ["#800000", "#FFFFFF"],
    sau: ["#008000", "#FFFFFF"],
    sgp: ["#FF0000", "#FFFFFF"],
    lka: ["#800000", "#FFD700"],
    syr: ["#FF0000", "#FFFFFF", "#000000", "#008000"],
    tjk: ["#FF0000", "#FFFFFF", "#008000"],
    tha: ["#FF0000", "#FFFFFF", "#0000FF"],
    tls: ["#FF0000", "#FFFF00", "#000000", "#FFFFFF"],
    tur: ["#FF0000", "#FFFFFF"],
    tkm: ["#008000", "#FFFFFF"],
    are: ["#FF0000", "#008000", "#FFFFFF", "#000000"],
    uzb: ["#0000FF", "#FFFFFF", "#FF0000", "#008000"],
    vnm: ["#FF0000", "#FFFF00"],
    yem: ["#FF0000", "#FFFFFF", "#000000"],
    alb: ["#FF0000", "#000000"],
    and: ["#0000FF", "#FFFF00", "#FF0000"],
    aut: ["#FF0000", "#FFFFFF"],
    blr: ["#FF0000", "#FFFFFF", "#008000"],
    bel: ["#FF0000"],
    bih: ["#0000FF", "#FFD700"],
    bgr: ["#FFFFFF", "#008000", "#FF0000"],
    hrv: ["#FF0000", "#FFFFFF", "#0000FF"],
    cyp: ["#0000FF", "#FFFFFF"],
    cze: ["#FFFFFF", "#FF0000", "#0000CC"],
    dnk: ["#FF0000", "#FFFFFF"],
    est: ["#0000FF", "#000000", "#FFFFFF"],
    fin: ["#FFFFFF", "#0000FF"],
    fra: ["#0000FF", "#FFFFFF", "#FF0000"],
    deu: ["#000000", "#FF0000", "#FFD700"],
    grc: ["#0000FF", "#FFFFFF"],
    isl: ["#0000CC", "#FFFFFF", "#FF0000"],
    ita: ["#008000", "#FFFFFF", "#FF0000"],
    lva: ["#FF0000", "#FFFFFF"],
    lie: ["#0000FF", "#FF0000"],
    ltu: ["#FFFF00", "#008000", "#FF0000"],
    lux: ["#FF0000", "#FFFFFF", "#75AADB"],
    mlt: ["#FF0000", "#FFFFFF"],
    mco: ["#FF0000", "#FFFFFF"],
    mne: ["#CC0000", "#CFB53B"],
    nld: ["#FF0000", "#FFFFFF", "#0000FF"],
    nor: ["#FF0000", "#FFFFFF", "#00008B"],
    pol: ["#FFFFFF", "#FF0000"],
    prt: ["#008000", "#FF0000"],
    rou: ["#0000FF", "#FFFF00", "#FF0000"],
    rus: ["#FFFFFF", "#0000FF", "#FF0000"],
    smr: ["#FFFFFF", "#007FFF"],
    srb: ["#FF0000", "#0000CC", "#FFFFFF"],
    svk: ["#FFFFFF", "#00008B", "#FF0000"],
    svn: ["#FFFFFF", "#0000FF", "#FF0000"],
    esp: ["#FF0000", "#FFD700"],
    swe: ["#0000FF", "#FFD700"],
    che: ["#FF0000", "#FFFFFF"],
    ukr: ["#0000FF", "#FFFF00"],
    eng: ["#cd0000", "#FFFFFF"],
    asm: ["#1A63C2", "#FF0000", "#FFFFFF"],
    aus: ["#008000", "#FFD700"],
    fji: ["#75AADB"],
    pyf: ["#FF0000", "#FFFFFF"],
    gum: ["#4F69C6", "#CA3435"],
    ncl: ["#A6AAAE", "#FF0000", "#FFFFFF"],
    nzl: ["#000000"],
    wsm: ["#FF0000", "#FFFFFF", "#0000FF"],
    slb: ["#497E48", "#FFFF00", "#0048ba"],
    ton: ["#FF0000", "#FFFFFF"],
    tuv: ["#76D7EA", "#FFFF66", "#FFFFFF"],
  },
  default: {
    dark: ['#FFFFFF','#7F7F7F'],
    light: ['#FFFFFF','#7F7F7F'],
    obsidian_blue: ['#FFFFFF','#7F7F7F'],
  }
};
